import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { SeguroService } from '../services/seguro.service';
import { ProfissionalService } from '../services/profissional.service';
import { SeguradoraService } from '../services/seguradora.service';
import { CorretoraService } from '../services/corretora.service';
import { VeiculoService } from '../services/veiculo.service';
import { UploaderService } from '../services/uploader.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-seguro-edit',
	templateUrl: './seguro-edit.component.html',
	styleUrls: ['./seguro-edit.component.css'],
	animations: [loadingFade]
})
export class SeguroEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public seguro_id = null;

	public formSeguro: FormGroup;
	public veiculo_array: NgOption[] = [];
	public seguradoras = [];
	public corretoras = [];
	public contatos = {'telefone1' : '','telefone2' : '','telefone3' : ''};

	//public file = [];
	public file_name = [];
	public file_name_upload = [];
	public file;

	public qtde_char_descricao = 0;

	// datepickers
	public seguro_data_contrato_dp;

	//filtro
	public seguro_valor___valorMin = null;
	public seguro_valor___valorMax = null;
	public seguro_vigencia___data_i = null;
	public seguro_vigencia___data_f = null;
	public veiculo_id___veiculo_id = null;
	public seguradora_id___seguradora_id = null;
	public corretora_id___corretora_id = null;

	public file_name_doc_veiculo;
	public file_name_apolice;

	public img_extensions = ['png', 'jpg', 'jpeg', 'pdf'];
	private imageDocVeiculo: string = '';
	private imageApolice: string = '';


	constructor(private authSvc: AuthService,
				private route: ActivatedRoute,
				private fb: FormBuilder,
				private seguroSvc: SeguroService,
				private seguradoraSvc: SeguradoraService,
				private corretoraSvc: CorretoraService,
				private profSvc: ProfissionalService,
				private uploaderSvc: UploaderService,
				private router: Router,
				private veiculoSvc: VeiculoService) { }

	ngOnInit() {
		this.criaForm();

		//this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {	


				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "seguradora_id___seguradora_id": { 
						 this.seguradora_id___seguradora_id = loSplitValor[1];
						 break; 
					  } 
					  case "corretora_id___corretora_id": { 
						this.corretora_id___corretora_id = loSplitValor[1];
						 break; 
					  } 
					  case "veiculo_id___veiculo_id": { 
						this.veiculo_id___veiculo_id = loSplitValor[1];
						 break; 
					  } 
					  case "seguro_vigencia___data_i": { 
						this.seguro_vigencia___data_i = loSplitValor[1];
						 break; 
					  }      
					  case "seguro_vigencia___data_f": { 
						this.seguro_vigencia___data_f = loSplitValor[1];
						 break; 
					  }      
					  case "seguro_valor___valorMin": { 
						this.seguro_valor___valorMin = loSplitValor[1];
						 break; 
					  } 
					  case "seguro_valor___valorMax": { 
						this.seguro_valor___valorMax = loSplitValor[1];
						 break; 
					  }                                                             
				   }
		
				  }
		
		
				}     

				this.seguro_id = params.id;
				// pega dados a partir do id
				this.seguroSvc.getSeguro(params.id).then((data: any) => {
					let seguro_data_contrato = null
					let seguro_vigencia = null
					data = data[0];

					if (moment(data.seguro_data_contrato).isValid()) {
						let moment_date = moment(data.seguro_data_contrato, 'YYYY-MM-DD');
						seguro_data_contrato = moment_date.format('DD/MM/YYYY');
					}
					if (moment(data.seguro_vigencia).isValid()) {
						let moment_date = moment(data.seguro_vigencia, 'YYYY-MM-DD');
						seguro_vigencia = moment_date.format('DD/MM/YYYY');
					}

					
					this.file_name_doc_veiculo = data.seguro_arq_documento_nome;
					this.file_name_apolice = data.seguro_arq_apolice_nome;
					
					this.preencheForm({
						seguro_id: data.seguro_id,
						usuario_id: this.authSvc.getUsuarioId(),
						unidade_id: data.unidade_id,
						cliente_id: data.cliente_id,
						veiculo_id: data.veiculo_id,
						seguro_apolice: data.seguro_apolice,
						seguro_ci: data.seguro_ci,
						seguro_valor: data.seguro_valor,
						seguro_rateio: data.seguro_rateio,
						seguro_data_contrato: seguro_data_contrato,
						seguro_vigencia: seguro_vigencia,
						seguradora_id: data.seguradora_id,
						corretora_id: data.corretora_id,
						seguro_descricao: data.seguro_descricao,
						seguro_solicitante: data.seguro_solicitante,
						seguro_aprovador : data.seguro_aprovador ,
						seguro_arq_documento: null,
						seguro_arq_apolice: null,
						// seguro_arq_documento: data.seguro_arq_documento,
						// seguro_arq_apolice: data.seguro_arq_apolice,
					});
					//this.onChangeCorretora(data.corretora_id);

					//if (data.seguro_descricao)
					//	this.qtde_char_descricao = data.seguro_descricao.length;

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formSeguro = this.fb.group({
			seguro_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			veiculo_id: [null, Validators.required],
			seguro_apolice: [null, Validators.required],
			seguro_ci: null,
			seguro_valor: ['', Validators.required],
			seguro_rateio: ['', Validators.required],
			seguro_data_contrato: [null, Validators.required],
			seguro_vigencia: [null, Validators.required],
			seguradora_id: null,
			corretora_id: null,
			seguro_descricao: ['', Validators.maxLength(200)],
			seguro_solicitante: ['', Validators.maxLength(100)],
			seguro_aprovador: ['', Validators.maxLength(100)],
			seguro_arq_documento: null,
			seguro_arq_apolice: null
		});

		this.pegaVeiculos();
		this.pegaSeguradoras();
		this.pegaCorretoras();
		moment.locale('pt-Br');
		this.seguro_data_contrato_dp = Datepicker('#seguro_data_contrato', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formSeguro.controls['seguro_data_contrato'].setValue(formatted);
			},
			onSelect: instance => {
				this.atualizaVigencia();
			}
		});
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			let dados = [];
			for(let veiculo of data){
				dados.push({
					veiculo_id: veiculo.veiculo_id,
					veiculo_label: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
					unidade_id: veiculo.unidade_id,
					cliente_id: veiculo.cliente_id
				});
			}
			this.veiculo_array = dados;
		}).catch((err) => {
			console.log(err)
		});
	}

	pegaSeguradoras() {
		this.seguradoraSvc.getSeguradoras().then((data: any[]) => {
			this.seguradoras = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaCorretoras() {
		this.corretoraSvc.getCorretoras().then((data: any[]) => {
			this.corretoras = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formSeguro.setValue(dados);
	}

	onChangeVeiculo(e) {
		this.formSeguro.controls['unidade_id'].setValue(e.unidade_id);
		this.formSeguro.controls['cliente_id'].setValue(e.cliente_id);
	}

	enviaSeguro() {
		if (this.formSeguro.valid) {
			this.submitting = true;
			let toSend = this.formSeguro.value;

			/*if(this.file.length > 0){
				let formData = new FormData();
				for(let i = 0; i < this.file.length; i++){
					if(this.file[i][0] != null){
						formData.append("file" + i, this.file[i][0],this.file_name_upload[i]);
					}
				}
				this.uploaderSvc.sendFile(formData);
			}*/

			toSend.seguro_arq_documento_nome = this.file_name_doc_veiculo;
			toSend.seguro_arq_apolice_nome = this.file_name_apolice;

			toSend.seguro_arq_documento_arquivo = this.imageDocVeiculo;
			toSend.seguro_arq_apolice_arquivo = this.imageApolice;

			if (this.seguro_id === null) { // criar
				this.seguroSvc.criaSeguro(toSend).then((data) => {
					Swal.fire({
						type:'success',
						title:'Seguro cadastrado com sucesso!',
						onClose:() => {
							this.router.navigate(['home/seguro']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.seguroSvc.editaSeguro(toSend).then((data) => {
					Swal.fire({
						type:'success',
						title:'Seguro alterado com sucesso!',
						onClose:() => {
							this.router.navigate(['home/seguro']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formSeguro.controls){
				let campo = this.formSeguro.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	onKeyUpDescricao(e) {
		this.qtde_char_descricao = this.formSeguro.value.seguro_descricao.length;
	}

	invalid(nome) {
		let input = this.formSeguro.get(nome);
		return input.touched && input.invalid;
	}

	atualizaVigencia(){
		let rateio = this.formSeguro.get('seguro_rateio').value;
		let seguro_data_contrato = this.formSeguro.get('seguro_data_contrato').value;
		if(rateio != null && seguro_data_contrato != null){
			if(rateio == 'A'){
				this.formSeguro.get('seguro_vigencia').setValue(moment(seguro_data_contrato, "DD/MM/YYYY").add(6, 'months').format('DD/MM/YYYY'));
			}
			else{
				this.formSeguro.get('seguro_vigencia').setValue(moment(seguro_data_contrato, "DD/MM/YYYY").add(1, 'years').format('DD/MM/YYYY'));
			}

		}
	}

	onChangeCorretora(e){
		if(e){
			this.contatos = {'telefone1' : e.corretora_tel1,'telefone2' : e.corretora_tel2,'telefone3' : e.corretora_tel3};
		}
		else{
			this.contatos = {'telefone1' : '','telefone2' : '','telefone3' : ''};
		}
	}

	//onDocumentoSelect(e){
	//	this.file[0] = <File>e.target.files;
	//	this.file_name[0] = this.file[0][0].name;
	//	this.file_name_upload[0] = this.file[0][0].name.split('.');
	//	this.file_name_upload[0] = this.file_name_upload[0][0] + moment().format('x') + '.' + this.file_name_upload[0][1];
	//}
	
	onApoliceSelect(e){
		this.file[1] = <File>e.target.files;
		this.file_name[1] = this.file[1][0].name;
		this.file_name_upload[1] = this.file[1][0].name.split('.');
		this.file_name_upload[1] = this.file_name_upload[1][0] + moment().format('x') + '.' + this.file_name_upload[1][1];
	}


	onClickVoltar(){
		//params = 'corretora_id___corretora_id=' + this.corretora_id___corretora_id;
		let params = "&seguradora_id___seguradora_id=" + this.seguradora_id___seguradora_id;
		params += "&veiculo_id___veiculo_id=" + this.veiculo_id___veiculo_id;
		params += "&seguro_vigencia___data_i=" + this.seguro_vigencia___data_i;
		params += "&seguro_vigencia___data_f=" + this.seguro_vigencia___data_f;
		params += "&seguro_valor___valorMin=" + this.seguro_valor___valorMin;
		params += "&seguro_valor___valorMax=" + this.seguro_valor___valorMax;
	
		this.router.navigate(['/home/segurofiltro/' + params]);
	
	  }

	_handleReaderLoaded_DocVeiculo(e) {
		let reader = e.target;
		this.imageDocVeiculo = reader.result;
		console.log("[imageDocVeiculo] = " + this.imageDocVeiculo);
	}	   

	_handleReaderLoaded_Apolice(e) {
		let reader = e.target;
		this.imageApolice = reader.result;
		console.log("[imageApolice] = " + this.imageDocVeiculo);
	}

	onDocumentoSelect(e, typeSend) {
	
		this.file = <File>e.target.files;
		if(typeSend == "DocVeiculo"){
			this.file_name_doc_veiculo = this.file[0].name;
		}else if(typeSend == "Apolice"){
			this.file_name_apolice = this.file[0].name;
		}


	}	


	  handleInputChange(e, typeSend) {

		this.onDocumentoSelect(e, typeSend)
		var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
		var pattern = /image-*/;
		var reader = new FileReader();
	 
		let arquivoErro = "";
		 let extensions = false;
		 let typeFile = file.type.split("/");

		 if(file.size > 1127979){

			if(typeSend == "DocVeiculo"){
				this.formSeguro.controls.seguro_arq_documento.setValue(null)
				this.file_name_doc_veiculo = "Selecionar arquivo";
				arquivoErro += "Documento do Veículo. ";
			}else if(typeSend == "Apolice"){
				this.formSeguro.controls.seguro_arq_apolice.setValue(null)
				this.file_name_apolice = "Selecionar arquivo";
				arquivoErro += "Apólice.  ";
			}

			alert('Arquivo ultrapassa o tamanho máximo de 1MB!');

			return;
		  }		 
	 
		 for(let type of this.img_extensions){
	 
		   if(type == typeFile[1]){
			 extensions = true;
		   }
	 
		 }

		if (!extensions) {

		   
		   if(typeSend == "DocVeiculo"){
			   this.formSeguro.controls.seguro_arq_documento.setValue(null)
			   this.file_name_doc_veiculo = "Selecionar arquivo";
			   arquivoErro += "Documento do Veículo. ";
		   }else if(typeSend == "Apolice"){
			   this.formSeguro.controls.seguro_arq_apolice.setValue(null)
			   this.file_name_apolice = "Selecionar arquivo";
			   arquivoErro += "Apólice.  ";
		   }

		   alert('Formato invalido! - ' + arquivoErro); 

		  return;		   
		}


		if(typeSend == "DocVeiculo"){
			reader.onload = this._handleReaderLoaded_DocVeiculo.bind(this);
			reader.readAsDataURL(file);
		}else if(typeSend == "Apolice"){
			reader.onload = this._handleReaderLoaded_Apolice.bind(this);
			reader.readAsDataURL(file);
		}

	  }



}
